"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluggableScatterPlot = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var sdk_ui_1 = require("@gooddata/sdk-ui");
var react_1 = tslib_1.__importDefault(require("react"));
var bucket_1 = require("../../../constants/bucket");
var supportedProperties_1 = require("../../../constants/supportedProperties");
var uiConfig_1 = require("../../../constants/uiConfig");
var bucketConfig_1 = require("../../../utils/bucketConfig");
var bucketHelper_1 = require("../../../utils/bucketHelper");
var propertiesHelper_1 = require("../../../utils/propertiesHelper");
var sort_1 = require("../../../utils/sort");
var scatterPlotUiConfigHelper_1 = require("../../../utils/uiConfigHelpers/scatterPlotUiConfigHelper");
var ScatterPlotConfigurationPanel_1 = tslib_1.__importDefault(require("../../configurationPanels/ScatterPlotConfigurationPanel"));
var PluggableBaseChart_1 = require("../baseChart/PluggableBaseChart");
var bucketHelper_2 = require("./bucketHelper");
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
/**
 * PluggableScatterPlot
 *
 * ## Buckets
 *
 * | Name             | Id                 | Accepts             |
 * |------------------|--------------------|---------------------|
 * | Measure (X-axis) | measures           | measures only       |
 * | Measure (Y-axis) | secondary_measures | measures only       |
 * | ViewBy           | attribute          | attributes or dates |
 *
 * ### Bucket axioms
 *
 * - |MeasureX| ≤ 1
 * - |MeasureY| ≤ 1
 * - |ViewBy| ≤ 1
 * - |MeasureX| + |MeasureY| ≥ 1
 *
 * ## Dimensions
 *
 * The PluggableScatterPlot always creates the same two dimensional execution.
 *
 * - ⊤ ⇒ [[...ViewBy], [MeasureGroupIdentifier]]
 *
 * ## Sorts
 *
 * The PluggableScatterPlot does not use any sorts.
 */
var PluggableScatterPlot = /** @class */ (function (_super) {
    tslib_1.__extends(PluggableScatterPlot, _super);
    function PluggableScatterPlot(props) {
        var _this = _super.call(this, props) || this;
        _this.type = sdk_ui_1.VisualizationTypes.SCATTER;
        _this.supportedPropertiesList = supportedProperties_1.SCATTERPLOT_SUPPORTED_PROPERTIES;
        _this.initializeProperties(props.visualizationProperties);
        return _this;
    }
    PluggableScatterPlot.prototype.getExtendedReferencePoint = function (referencePoint) {
        var clonedReferencePoint = cloneDeep_1.default(referencePoint);
        var newReferencePoint = tslib_1.__assign(tslib_1.__assign({}, clonedReferencePoint), { uiConfig: cloneDeep_1.default(uiConfig_1.DEFAULT_SCATTERPLOT_UICONFIG) });
        newReferencePoint = bucketHelper_1.removeAllArithmeticMeasuresFromDerived(newReferencePoint);
        newReferencePoint = bucketHelper_1.removeAllDerivedMeasures(newReferencePoint);
        newReferencePoint[bucket_1.BUCKETS] = bucketHelper_2.transformBuckets(newReferencePoint.buckets);
        newReferencePoint = scatterPlotUiConfigHelper_1.setScatterPlotUiConfig(newReferencePoint, this.intl, this.type);
        newReferencePoint = bucketConfig_1.configurePercent(newReferencePoint, true);
        newReferencePoint = bucketConfig_1.configureOverTimeComparison(newReferencePoint, !!this.featureFlags["enableWeekFilters"]);
        newReferencePoint = propertiesHelper_1.getReferencePointWithSupportedProperties(newReferencePoint, this.supportedPropertiesList);
        newReferencePoint = sort_1.removeSort(newReferencePoint);
        return Promise.resolve(bucketHelper_1.sanitizeFilters(newReferencePoint));
    };
    PluggableScatterPlot.prototype.renderConfigurationPanel = function (insight) {
        var configPanelElement = this.getConfigPanelElement();
        if (configPanelElement) {
            this.renderFun(react_1.default.createElement(ScatterPlotConfigurationPanel_1.default, { locale: this.locale, references: this.references, properties: this.visualizationProperties, propertiesMeta: this.propertiesMeta, insight: insight, colors: this.colors, pushData: this.handlePushData, type: this.type, isError: this.getIsError(), isLoading: this.isLoading, featureFlags: this.featureFlags }), configPanelElement);
        }
    };
    return PluggableScatterPlot;
}(PluggableBaseChart_1.PluggableBaseChart));
exports.PluggableScatterPlot = PluggableScatterPlot;
//# sourceMappingURL=PluggableScatterPlot.js.map